'use strict';

class ResumenComputosController {
  constructor() {
    'ngInject';
  }

  $onInit() {

  }

}

export default ResumenComputosController;



// WEBPACK FOOTER //
// ./src/app/components/reg-empresas/computo-proyecto/resumen/resumen.controller.js